import List from '@mui/material/List';

function SidebarGroup(props) {
  return <List disablePadding {...props} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
